// Recommendation rail measurement: impression at first visibility (50%), click on a card.
// Publishes on the Shopify analytics bus (Shopify.analytics.publish); a custom pixel relays
// it. No network request here, no dependency. Works for the native block (cards injected
// later) and for server-rendered rails (cards present in the HTML).

// Theme product cards, and rows of the compact list (sold-out product page) that are not
// product-card elements but carry data-reco-item + data-product-id.
const CARD = 'product-card[data-product-id], [data-reco-item][data-product-id]';

export function publish(name, payload) {
  const bus = globalThis.Shopify && globalThis.Shopify.analytics;
  if (!bus || typeof bus.publish !== 'function') return false;
  bus.publish(name, payload);
  return true;
}

export function viewPayload(rail) {
  const cards = Array.from(rail.querySelectorAll(CARD));
  return {
    rail: rail.getAttribute('data-rail'),
    source_product_id: rail.getAttribute('data-source-product-id'),
    product_ids: cards.map((c) => c.getAttribute('data-product-id')),
    count: cards.length,
  };
}

export function clickPayload(rail, card) {
  const cards = Array.from(rail.querySelectorAll(CARD));
  return {
    rail: rail.getAttribute('data-rail'),
    source_product_id: rail.getAttribute('data-source-product-id'),
    product_id: card.getAttribute('data-product-id'),
    position: cards.indexOf(card),
  };
}

export function findCard(target, rail) {
  let node = target;
  while (node && node !== rail) {
    if (typeof node.matches === 'function' && node.matches(CARD)) return node;
    node = node.parentElement;
  }
  return null;
}

const seen = new WeakSet();

function publishView(rail) {
  if (seen.has(rail)) return;
  const payload = viewPayload(rail);
  if (payload.count === 0) return; // native block not filled yet: wait for the cards
  seen.add(rail);
  publish('dyncel_rail_view', payload);
}

function watchUntilFilled(rail) {
  if (rail.querySelector(CARD)) { publishView(rail); return; }
  const mo = new MutationObserver(() => {
    if (rail.querySelector(CARD)) { mo.disconnect(); publishView(rail); }
  });
  mo.observe(rail, { childList: true, subtree: true });
}

export function initRailTracking(root = document) {
  const rails = Array.from(root.querySelectorAll('[data-rail]'));
  if (rails.length === 0) return;

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      io.unobserve(entry.target);
      watchUntilFilled(entry.target);
    }
  }, { threshold: 0.5 });
  rails.forEach((r) => io.observe(r));

  root.addEventListener('click', (event) => {
    const rail = event.target.closest && event.target.closest('[data-rail]');
    if (!rail) return;
    const card = findCard(event.target, rail);
    if (!card) return;
    publish('dyncel_rail_click', clickPayload(rail, card));
  }, { capture: true, passive: true });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRailTracking());
  } else {
    initRailTracking();
  }
}
